export default __webpack_public_path__ + "static/media/header.b13b2138.png";